import { createContext, useContext } from "react";

export type RefetchProjectFn = () => Promise<unknown>;

const MarkNotSuitableRefetchContext = createContext<RefetchProjectFn | null>(
  null
);

export const MarkNotSuitableRefetchProvider =
  MarkNotSuitableRefetchContext.Provider;

export function useMarkNotSuitableRefetchProject(): RefetchProjectFn | null {
  return useContext(MarkNotSuitableRefetchContext);
}
